import { useMemo } from 'react'

import { AgChartOptions } from 'ag-charts-community'

import { CustomAgChart } from '@fortem-monorepo/react-ag'

import { ICReportChartPrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { diversifiers } from '@/react-query/queries/ic-report/hooks'

export interface RatesDeltaChartProps extends ICReportChartPrimitive {}

export const RatesDeltaChart: React.FC<RatesDeltaChartProps> = ({ params, options }) => {
  const query = diversifiers.useRatesVolatilities(params)
  const data = query.data ?? []

  const formattedData = useMemo(() => {
    return data.map((item: any) => ({ ...item, date: new Date(item.date) }))
  }, [data])

  const mergedOptions: AgChartOptions = {
    title: {
      text: 'Net Delta',
      fontSize: 14,
    },
    data: formattedData,
    series: [
      {
        type: 'line',
        xKey: 'date',
        yKey: 'SGIVR2UD Delta',
        marker: {
          size: 0,
        },
      },
    ],
    axes: [
      {
        type: 'time',
        position: 'bottom',
        label: { format: '%d %b %y' },
        nice: false,
      },
      { type: 'number', position: 'left' },
    ],
    ...options,
  }

  return <CustomAgChart options={mergedOptions} />
}
